/**
 * Download an array of objects as a CSV file.
 * @param {Array<Object>} data - Array of row objects
 * @param {string} filename - Filename for the download (e.g. 'export.csv')
 */
export const downloadCSV = (data, filename) => {
    if (!data?.length) return;
    const headers = Object.keys(data[0]);
    const csvRows = [
        headers.join(','),
        ...data.map((row) =>
            headers
                .map((h) => JSON.stringify(row[h] ?? ''))
                .join(',')
        ),
    ];
    const blob = new Blob([csvRows.join('\n')], {
        type: 'text/csv;charset=utf-8;',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
};
